import { Injectable } from '@angular/core';
import { LanguageService } from './language.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../core/alert/alert.component';
import { Alert, AskingAlert } from '../models/alert';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    constructor(protected dialog: MatDialog, private languageService: LanguageService) {}

    /** Alert texts are written in English; show them in the selected language. */
    private translateTexts(data: any): any {
        if (!data || typeof data !== 'object') return data;
        const out = { ...data };
        for (const field of ['heading', 'subHeading', 'message', 'leftButton', 'rightButton', 'btnSuccess', 'linkText']) {
            if (typeof out[field] === 'string' && out[field]) out[field] = this.languageService.instant(out[field]);
        }
        return out;
    }

    private openAlertDialog(type: string, data: any, width: string = '380px', cancelAble: boolean = false) {
        return new Promise((resolve, reject) => {
            const dialogRef = this.dialog.open(AlertComponent, {
                width,
                data: {
                    type,
                    imagePath: this.getImagePath(type),
                    data: this.translateTexts(data)
                },
                disableClose: cancelAble,
            });

            dialogRef.afterClosed().subscribe((result: any) => {
                resolve(result);
            });
        });
    }

    private getImagePath(type: string): string {
        switch (type) {
            case 'success':
                return '/icons/ic_alert_success.svg';
            case 'error':
                return '/icons/ic_alert_error.svg';
            default:
                return '';
        }
    }

    success(data: Alert) {
        return this.openAlertDialog('success', data, '380px', data.cancelAble);
    }

    error(data: Alert) {
        return this.openAlertDialog('error', data, '380px');
    }

    askAlert(data: AskingAlert, width: string = '500px') {
        return this.openAlertDialog('ask', data, width, true);
    }
}
